<template>
  <main>
    <h2 class="ttl">
      <img
        src="/img/ico_user2.png"
        alt="会員情報の更新"
        width="40"
        class="mb30"
      /><br />{{ $t("verificationCodeBis") }}
    </h2>
    <div class="account-box">
      <dl>
        <dt>{{ $t("verificationCode") }}</dt>
        <dd>
          <input
            type="text"
            v-model="verificationCode"
            id="verificationCode"
            name="verificationCode"
            :placeholder="placeholder"
          />
          <br />
        </dd>
      </dl>
    </div>
    <p class="txt-error center mb40" v-if="codeError">
      {{ $t("errorValidationPhone") }}
    </p>
    <p class="btn-normal">
      <button @click="validateCode" id="phoneButton">
        {{ $t("validateCode") }}
      </button>
    </p>
  </main>
</template>

<script>
import firebase from "firebase";
import redirectEnum from "@/constants/redirectEnum";
export default {
  name: "SigninValidatePhoneCode",
  data() {
    return {
      placeholder: this.$t("code"),
      phoneError: false,
      verificationCode: "",
      confirmationResult: "",
      phone: "",
      redirectId: "",
      pid: "",
      source: "",
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      codeError: false,
    };
  },
  created() {
    this.confirmationResult = this.$route.params.confirmationResult;
    this.phone = this.$route.params.phone;
    this.redirectId = this.$route.params.redirectId;
    this.pid = this.$route.params.pid;
    this.source = this.$route.params.source;
  },
  watch: {
    verificationCode() {
      this.codeError = false;
    },
  },
  methods: {
    async validateCode() {
      try {
        let res = await this.confirmationResult.confirm(this.verificationCode);
        this.writeLog(res);
        this.$router.push({ name: "Home" });
      } catch (error) {
        // user couldn't sign in (bad verification code)
        this.codeError = true;
      }
    },
    async writeLog(cred) {
      let redirectId = this.redirectId;
      let pid = this.pid;
      let source = this.source;
      if (pid == "0200001400" && redirectId == "job") {
        source = window.location.href.replace("job", "shopping");
        pid = "0600001400";
        redirectId = "shopping";
      }
      const logRef = this.db.collection("usersLog").doc();
      await logRef.set({
        uid: cred.user.uid,
        type: "signin",
        source: source,
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
      });
      if (
        redirectId !== undefined &&
        redirectEnum.redirects[redirectId] !== undefined
      ) {
        await logRef.set({ redirectId: redirectId }, { merge: true });
        if (pid !== undefined) {
          await logRef.set({ pid: pid }, { merge: true });
          this.$router.push("/");
        } else {
          if (
            redirectEnum.redirects[redirectId].includes("http") &&
            pid == undefined
          ) {
            window.location.href = redirectEnum.redirects[redirectId];
          } else {
            this.$router.push({
              name: "Partner",
              query: { target: redirectId },
            });
            //this.$router.push('/'+redirectEnum.redirects[redirectId]);
          }
        }
      } else {
        if (this.redirect) {
          this.$router.push(this.redirect);
        } else {
          this.$router.push("/");
        }
      }
    },
  },
};
</script>
